var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('p',[_vm._v("404")]),_c('span',[_vm._v("Ops! Esta página não existe.")]),_c('AppButton',{attrs:{"text":"Voltar"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }